import styled from '@emotion/styled'

export const VatDeclarationsTableWrapper = styled.section`
  flex: 1;
`
